import { createTheme } from '@mui/material/styles';

declare module '@mui/material/styles' {
  interface PaletteOptions {
    [key: string]: any;
  }
}

export default createTheme({
  palette: {
    background: {
      default: '#e1f5fe',
      paper: '#fff',
    },
    primary: {
      light: '#015384',
      main: '#0277bd',
      dark: '#3492ca',
    },
    secondary: {
      light: '#51b7ae',
      main: '#26a69a',
      dark: '#1a746b',
    },
    subtitle: '#505050',
    contrastText: '#fff',
  },
});
